interface Coordinates {
  lat: string
  long: string
}

export const getGoogleMapsLinkByCoordinates = ({lat, long}: Coordinates): string => {
  return `https://www.google.com/maps/search/?api=1&query=${lat},${long}`
}
